<template>
	<div class="tab">
		<div class="search-box">
			<search :cate-list="cateList" @onSubmit="onSubmit" :viewValue="viewValue" />
		</div>
		<div class="flex flex-align-center mt-20 mb-20 flex-just-between">
			<div v-if="$auth.hasPermi('cps:trd:ranking:export-commander-ranking')">
				<export-list
					ref="exportList"
					:routerPath="routerPath"
					:platformId="platformId"
					:exportInterface="exportInterface"
					:exportDialog="exportDialog"
					:reversal="false"
				></export-list>
			</div>
			<div class="flex flex-align-center">
				<p class="yx-color-blue-6 fz-14 mr-16">数据更新时间：{{ refreh_time }}</p>
				<date
					:clearable="false"
					ref="dateRef"
					:isToDay="true"
					weekMonth
					:startEndTime="startEndTime"
					:disableDays="180"
					@changeDate="changeDate"
				></date>
				<div class="see-auth view pointer flex flex-align-center fz-14" v-if="$auth.hasPermi('ranking:get-view-commander-config')">
					<div class="ml-10">
						<el-select
							v-model="viewValue"
							@change="selectFun"
							class="small-select-input"
							popper-class="small-select-option"
							:popper-append-to-body="false"
							placeholder="请选择"
						>
							<el-option v-for="item in viewOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
						</el-select>
					</div>
				</div>
			</div>
		</div>
		<el-table
			class="table-wrapper"
			@sort-change="sortChange"
			v-loading="loading"
			v-horizontal-scroll="'always'"
			v-sticky-header
			element-loading-text="加载中"
			element-loading-background="rgba(255, 255, 255)"
			:data="list"
			header-row-class-name="table-header-row"
			row-class-name="table-row"
		>
			<el-table-column label="排行" width="80">
				<template v-slot="{ row }">
					<div v-if="row.index < 4">
						<svg class="icon" aria-hidden="true">
							<use :xlink:href="'#icon-a-' + row.index"></use>
						</svg>
					</div>
					<div v-else>
						{{ row.index }}
					</div>
				</template>
			</el-table-column>
			<el-table-column label="团长信息" min-width="250">
				<template v-slot="{ row }">
					<div class="top flex flex-align-center">
						<platform-icon :platformId="row.platform_id"></platform-icon>
						<p class="ml-4 title">{{ row.sec_institution_name }}</p>
					</div>
				</template>
			</el-table-column>
			<el-table-column label="出单商品数" min-width="150">
				<template v-slot="{ row }">
					<p :class="[isClick ? 'yx-color-primary pointer' : '']" @click="seeInfo(row.sec_institution_id)">{{ row.product_num }}</p>
				</template>
			</el-table-column>
			<el-table-column label="支付订单量" sortable="custom" prop="order_num" min-width="100">
				<template v-slot="{ row }">
					<p>{{ row.order_num }}</p>
				</template>
			</el-table-column>
			<el-table-column label="支付订单金额" sortable="custom" prop="money" min-width="100">
				<template v-slot="{ row }">
					<p>
						<span class="fz-12 DIN">¥</span>
						{{ row.money }}
					</p>
				</template>
			</el-table-column>
			<empty :isSearch="isSearch" btnText="同步团长商品" ref="empty" slot="empty"></empty>
		</el-table>
		<bottomfixed class="pagination-fixed">
			<yx-pagination
				class="bottom-pagination"
				:total="total"
				:current-page="pageInfo.page"
				:page-size="pageInfo.page_size"
				@size-change="sizeChange"
				@current-change="currentChange"
			></yx-pagination>
		</bottomfixed>
		<info-drawer ref="infoDrawer"></info-drawer>
	</div>
</template>
<script>
import search from './search.vue';
import { mapGetters } from 'vuex';
import empty from '@/views/common/empty/index.vue';
import { rankingSecondaryDetail, rankingExport } from '@/api/ranking';
import infoDrawer from '../../../components/infoDrawer';
import date from '@/views/common/date';
import exportList from '@/views/common/exportList';
import { calDate } from '@/utils/common';
import bottomfixed from '@/components/ui/bottomFixed/bottomFixed.vue';
export default {
	name: 'tab',
	components: {
		search,
		empty,
		infoDrawer,
		date,
		exportList,
		bottomfixed,
	},
	props: ['platformId', 'viewOptions'],
	computed: {
		...mapGetters(['isShopPartnerDataView']),
		isClick() {
			return this.$auth.hasPermi('ranking:ranking-Commander-details');
		},
	},
	data() {
		return {
			cateList: [],
			options: { selectable: false },
			list: [],
			total: '0',
			pageInfo: {
				page: 1,
				page_size: 10,
			},
			loading: false,
			isSearch: false,
			form: {
				end_time: '',
				begin_time: '',
			},
			params: {},
			refreh_time: '',
			startEndTime: [],
			routerPath: '/ranking/issueHeader/record',
			rankType: 2,
			viewValue: 2,
		};
	},
	created() {
		this.startEndTime =
			this.$route?.query.startEndTime?.split(',').map(timestamp => {
				return new Date(+timestamp * 1000);
			}) || calDate(7);
		this.$nextTick(() => {
			this.$refs.dateRef.getData();
		});
	},
	methods: {
		async getList(isSearch) {
			const { platformId: platform_id, rankType: type } = this;
			this.isSearch = Boolean(isSearch);
			this.loading = true;
			const {
				code,
				data: { total = 0, result = [], refrehTime = '' },
			} = await rankingSecondaryDetail({
				platform_id,
				type,
				...this.pageInfo,
				...this.form,
				...this.params,
			});
			if (code !== 0) return;
			this.list = result;
			this.total = total + '';
			this.refreh_time = refrehTime;
			this.loading = false;
		},
		changeDate({ from_time, to_time }) {
			this.form = {
				begin_time: from_time,
				end_time: to_time,
			};
			this.getList();
		},
		sizeChange(size) {
			this.pageInfo.page_size = size;
			this.getList();
		},
		currentChange(index) {
			this.pageInfo.page = index;
			this.getList();
		},
		refreshPage() {
			this.pageInfo = {
				page: 1,
				page_size: 10,
			};
		},
		refresh() {
			this.getList();
		},
		selectFun(e) {
			this.rankType = e;
			this.getList();
		},
		//筛选
		onSubmit(val) {
			this.params = val;
			this.pageInfo.page = 1;
			this.getList(1);
		},
		errorHandler() {
			return true;
		},
		async seeInfo(sec_institution_id) {
			if (!this.isClick) return;
			const { platformId: platform_id, rankType: type } = this;
			let params = {
				sec_institution_id,
				platform_id,
				type,
				deptIds: this.params.deptIds,
				talentUserIds: this.params.talentUserIds || [],
				bdUserIds: this.params.bdUserIds || [],
				...this.form,
			};
			this.$refs.infoDrawer.show(1, '出单商品信息', params, 1);
		},
		sortChange({ prop, order }) {
			let orderBy = order === 'ascending' ? prop + ' asc' : order === 'descending' ? prop + ' desc' : '';
			this.params.order = orderBy;
			this.getList();
		},
		async exportInterface(that) {
			that.$refs.exportDialog.show(this.exportDialog);
		},
		async exportDialog() {
			const { platformId: platform_id, rankType: type, routerPath } = this;
			const { code } = await rankingExport({
				platform_id,
				type,
				ranking: 'secondary',
				...this.pageInfo,
				...this.form,
				...this.params,
			});
			if (code === 0) {
				const handLink = this.$router.resolve({
					path: routerPath,
					query: { platform_id },
				});
				window.open(handLink.href, '_blank');
			}
		},
	},
};
</script>
<style lang="less" scoped>
.icon {
	width: 20px;
	height: 20px;
}
.id-tag {
	border-radius: 2px;
	background-color: #f5f5f5;
	height: 18px;
	width: 18px;
	line-height: 18px;
	text-align: center;
	font-size: 14px;
	color: #999;
}
.small-select-input {
	/deep/ input {
		border: none;
		background-color: #f7f8fa;
		border-radius: 2px;
	}
	/deep/ .el-icon-arrow-up:before {
		content: '\e78f';
	}
	/deep/ .el-select__caret {
		color: #646566;
	}
}
/deep/ .el-avatar {
	background: #fff;
}
/deep/ .el-table-horizontal-scrollbar {
	display: block !important;
	opacity: 0;
}
.table-wrapper {
	margin-bottom: 60px;
}
.table-wrapper:hover {
	/deep/ .el-table-horizontal-scrollbar {
		opacity: 1 !important;
	}
}
.el-table::before {
	display: none !important;
}
.el-table {
	/deep/ .el-table__fixed::before {
		display: none !important;
	}
	/deep/ .el-table__fixed-right::before {
		display: none !important;
	}
}
// 隐藏滚动条
/deep/ .el-table__body-wrapper::-webkit-scrollbar {
	/*width: 0;宽度为0隐藏*/
	width: 0px;
}

/deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
	border-radius: 2px;
	height: 50px;
	background: #eee;
}
/deep/ .el-table__body-wrapper::-webkit-scrollbar-track {
	box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
	border-radius: 2px;
	background: rgba(0, 0, 0, 0.4);
}

/deep/ .el-table--scrollable-y .el-table__body-wrapper {
	overflow: hidden !important;
}

/deep/ .el-table--scrollable-x .el-table__body-wrapper {
	overflow: hidden !important;
}
.bottom-pagination {
	position: absolute;
	right: 12px;
}
</style>
